export const constants = {
  server: 'https://us-central1-digitaltextbook.cloudfunctions.net/serverResponse'
}